module.exports = __webpack_public_path__ + "static/img/v_6.f45a4007.png";